import { PAGE_SEO_CONTENT, SEO_DEFAULT_DESCRIPTION, SEO_DEFAULT_TITLE } from './seoPages';

const FALLBACK_SITE_URL = 'http://localhost:5173';

export const SEO_SITE_URL = (import.meta.env.VITE_SITE_URL || '').replace(/\/$/, '')
  || (typeof window !== 'undefined' ? window.location.origin.replace(/\/$/, '') : FALLBACK_SITE_URL);

export { SEO_DEFAULT_TITLE, SEO_DEFAULT_DESCRIPTION };

export const SEO_DEFAULT_IMAGE = `${SEO_SITE_URL}/logo_site_x64.png`;
export const PAGE_SEO = PAGE_SEO_CONTENT;

export function buildCanonicalUrl(path = '/') {
  return new URL(path, SEO_SITE_URL).toString();
}
